import { useState } from 'react';
import React from 'react';
import { FilteredActivityFeedTypes } from '@components/Feed/store';
import { useActivityFeed } from '@components/Feed/useActivityFeed';
import { LandingHeading } from '@components/Landing/shared/LandingHeading';
import { Chip } from '@components/main-components/elements/chips/Chip';
import { useAuth } from '@context/auth/base';
import { useConnectedAuth } from '@context/auth/connected';
import { ActivityFeedGroupFilterOption } from '@graphql/reactQuery';

import { NAV_LINKS } from '@utils/constants';
import { FreshlyMinted } from './FreshlyMinted';
import { PeopleFollowMintedFeed } from './PeopleFollowFeed';

enum FreshlyMintedStatusEnum {
  TOP_COLLECTORS = 'TOP_COLLECTORS',
  FOLLOWING = 'FOLLOWING',
}

const Heading = ({ selected }: { selected: string }) => {
  const { setActivityFeedGroupFilter, setActivityFeedFilter } = useActivityFeed({
    disabled: true,
  });

  const setFollowFilter = () => {
    setActivityFeedGroupFilter([ActivityFeedGroupFilterOption.Collected]);
    setActivityFeedFilter(FilteredActivityFeedTypes.User);
  };

  const setNotableCollectorsFilter = () => {
    setActivityFeedGroupFilter([ActivityFeedGroupFilterOption.Collected]);
    setActivityFeedFilter(FilteredActivityFeedTypes.NotableCollectors);
  };

  return (
    <LandingHeading
      header="Freshly Minted"
      pathnameUri={NAV_LINKS.Feed}
      onHeaderClick={() => {
        if (selected === FreshlyMintedStatusEnum.TOP_COLLECTORS) {
          setNotableCollectorsFilter();
        } else {
          setFollowFilter();
        }
      }}
    />
  );
};

const Chips = ({
  selected,
  setCollectors,
  setFollowing,
}: {
  selected: string;
  setCollectors: (status: FreshlyMintedStatusEnum.TOP_COLLECTORS) => void;
  setFollowing: (status: FreshlyMintedStatusEnum.FOLLOWING) => void;
}) => {
  const { isAuthenticatedWithAPI } = useAuth();
  const { login } = useConnectedAuth();

  return (
    <div className="mb-2 flex items-center gap-2 sm:mb-4">
      <Chip
        text="Top Collectors"
        isSelected={selected === FreshlyMintedStatusEnum.TOP_COLLECTORS}
        onClick={() => setCollectors(FreshlyMintedStatusEnum.TOP_COLLECTORS)}
      />
      <Chip
        text="Following"
        isSelected={selected === FreshlyMintedStatusEnum.FOLLOWING}
        onClick={() => {
          if (!isAuthenticatedWithAPI) {
            login();
            return;
          }

          setFollowing(FreshlyMintedStatusEnum.FOLLOWING);
        }}
      />
    </div>
  );
};

export const FreshlyMintedSelector = () => {
  const [selected, setSelected] = useState(FreshlyMintedStatusEnum.TOP_COLLECTORS);

  return (
    <div className="w-full px-4 md:px-6">
      <Heading selected={selected} />
      <Chips
        selected={selected}
        setCollectors={() => setSelected(FreshlyMintedStatusEnum.TOP_COLLECTORS)}
        setFollowing={() => setSelected(FreshlyMintedStatusEnum.FOLLOWING)}
      />

      {selected === FreshlyMintedStatusEnum.TOP_COLLECTORS && <FreshlyMinted />}
      {selected === FreshlyMintedStatusEnum.FOLLOWING && <PeopleFollowMintedFeed hideTitle />}
    </div>
  );
};
